// brex mimics the corp tenant — reuse capone-corporate's terms Body.
import Body from "../capone-corporate/Body";

export default Body;
